import { render, staticRenderFns } from "./ProfileLayout.vue?vue&type=template&id=67d8242c&"
import script from "./ProfileLayout.vue?vue&type=script&lang=js&"
export * from "./ProfileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports